import { ReactElement } from 'react';

import { ClassNameProp } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { useVisitSettlementStatusGlobalState } from '../shared/statusResolver/useVisitSettlementStatusGlobalState';
import { translationKeys } from '../translations';

type VisitSettlementStatusDescriptionProps = ClassNameProp & {
   readonly appointmentId: number;
};

export const VisitSettlementStatusDescription = (props: VisitSettlementStatusDescriptionProps): ReactElement | null => {
   const { getStatus } = useVisitSettlementStatusGlobalState();
   const status = getStatus(props.appointmentId);

   if (!status) {
      return null;
   }

   return <Translate>{translationKeys.statusDescription[status]}</Translate>;
};
